export default __webpack_public_path__ + "static/media/new-donation-illustration.54655853.png";